import React, { Component } from 'react'
import { PageContent, PageTitle } from "../PageContent/PageContent"
import ScreenSelector from "../ScreenSelector"

interface Props {
    title: string
    screens: ITabScreen[]
}

interface State {
    selectedScreenName: string
}

interface ITabScreen {
    name: string
    displayName?: string
    screen: any
}

export default class TabScreen extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            selectedScreenName: props.screens[0].name
        }
    }

    componentDidMount(): void {
        let hash = (window.location.hash || "#").substring(1).trim()
        
        if (hash) {
            this.setState({ selectedScreenName: hash })
        }
    }

    render() {
        let {title, screens, children} = this.props
        let {selectedScreenName} = this.state
        let selectedScreen = screens.find(s => s.name == selectedScreenName)?.screen

        return (
            <PageContent className="">
                <PageTitle title={title}></PageTitle>
                <div className="screen-selector-row has-spacing subject-buttons view-change-buttons-container inline-buttons inline-btns">
                    {screens.map(s => 
                        <ScreenSelector key={`tab-screen-${s.name}`} 
                            active={selectedScreenName === s.name}
                            displayName={s.displayName || s.name}
                            onSwitchComponent={() => {
                                this.setState({ selectedScreenName: s.name })
                                window.location.hash = s.name
                            }}
                        />
                    )}
                    {selectedScreen}
                    {children}
                </div>
            </PageContent>
        )
    }
}
